<template>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
     :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="total">
    </el-pagination>
</template>

<script>
export default {
    props:{
        total:{
            type:Number,
            default:10
        },
        pageSize:{
            type:Number,
            default:10
        }
    },
    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.$emit('currentChange',val)
        }
    },
    data() {
        return {
            currentPage: 1,
        };
    }
}
</script>

<style>

</style>